import { ManagedDomEventListeners } from '@ipfabric/ui-components/utils/dom/ManagedDomEventListeners';
import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';

/**
 * Disable browser selection when mouse is held on the graph,
 * otherwise graph dragging could collide with browser selection dragging.
 */
export const disableTextSelection: GraphRendererPlugin = (pluginInterface) => {
  const { interaction } = pluginInterface.app.renderer.plugins;
  interaction.on('mousedown', () => {
    window.getSelection()?.removeAllRanges();
    const listeners = new ManagedDomEventListeners(
      [
        window,
        'selectstart',
        (e: Event) => {
          e.preventDefault();
        },
      ],
      [
        window,
        'mouseup',
        () => {
          listeners.remove();
        },
      ],
    );
  });
};
